import r from"@brazilian-utils/helper-only-numbers";var n=function(r){return 8===r.length};export default function(t){if(!t)return!1;var e=r(t);return n(e)};
//# sourceMappingURL=index.m.js.map
